import * as yup from "yup";
import Swal from "sweetalert2";
export const JSONParser = (str, def) => {
  try {
    return JSON.parse(str) || def;
  } catch (e) {
    console.warn(e);
    return def;
  }
};

export const locationParams = (search) => {
  const searchParams = new URLSearchParams(search);
  const ob = {};
  searchParams.forEach(function (value, key) {
    ob[key] = value;
  });
  return ob;
};

export const AgencyDeleteFunction = () => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "This Agency is deleted Please Login again!",
    confirmButtonText:
      '<i style={{color:"white"}} class="fa fa-thumbs-up"><a href="/agency/dashboard"/></i> OkaY!',
  });
};

export function PhoneNumberschema() {
  const value = "78ioioin";
  const validations = [{ type: "vbn", params: "7999" }];

  const schema = {};
  const num = value.match(/\d+/g);
  if (!yup["number"]) {
    return schema;
  }
  if (num.toString().length <= 10) {
    return schema;
  }
  let validator = yup["number"]();
  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...params);
  });
  schema[value] = validator;
  return schema;
}

export function CardSwipe(value = "") {
  const EqualPresent = value.includes("=");
  const firstcar = value.substring(0, 2);
  const CaretPresent = value.includes("^");
  try {
    if (firstcar.toUpperCase() === "5B") {
      const ind = value.indexOf("=") - 16;

      if (value.indexOf("=") > 0) {
        const CreditCardNumber = value.substring(ind, 16);
        return {
          cardNumber: CreditCardNumber,
        };
      }
    } else if (CaretPresent) {
      const CardData = value.split("^");

      //%B1234123412341234^CardUser/John^030510100000019301000000877000000?
      const [firstName, lastName] = CardData[1].split("/");

      const CreditCardNumber = CardData[0];

      const ExpirationMM = CardData[2].substring(2, 4);

      const ExpirationYY = CardData[2].substring(0, 2);
      return {
        firstName,
        lastName,
        cardNumber: CreditCardNumber,
        expirationMonth: ExpirationMM,
        expirationYear: ExpirationYY,
      };
    } else if (EqualPresent) {
      const CardData = value.split("=");

      //1234123412341234=0305101193010877?

      const CreditCardNumber = CardData[0];

      const ExpirationMM = CardData[1].substring(2, 4);
      const ExpirationYY = CardData[1].substring(0, 2);
      return {
        cardNumber: CreditCardNumber,
        expirationMonth: ExpirationMM,
        expirationYear: ExpirationYY,
      };
    } else {
      return {
        cardNumber: value,
      };
    }
  } catch (error) {
    return {
      cardNumber: value,
    };
  }
}

// Apply the Luhn checksum test.  Returns true on a valid account number.
// The input is assumed to be a string containing only digits.
export const luhnChecksum = function (digits) {
  const map = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let sum = 0;

  // Proceed right to left. Even and odd digit positions are handled differently.
  let n = digits.length;
  let odd = true;
  while (n--) {
    const d = parseInt(digits.charAt(n), 10);
    if (odd) {
      // Odd digits used as is
      sum += d;
    } else {
      // Even digits mapped
      sum += map[d];
    }

    odd = !odd;
  }

  return sum % 10 === 0 && sum > 0;
};
export const parseCreditCards = (inpValue) => {
  const creditCardParsers = [
    // Visa card parser.
    function (rawData) {
      // Visa issuer number begins with 4 and may vary from 13 to 19 total digits. 16 digits is most common.
      const pattern = new RegExp(
        "^%B(4[0-9]{12,18})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})"
      );

      const match = pattern.exec(rawData);
      if (!match) return null;

      const account = match[1];
      if (!luhnChecksum(account)) return null;

      const cardData = {
        type: "visa",
        cardNumber: account,
        lastName: match[2].trim(),
        firstName: match[3].trim(),
        honorific: match[4] ? match[4].trim().slice(1) : "",
        expirationYear: match[5],
        expirationMonth: match[6],
      };

      return cardData;
    },

    // MasterCard parser.
    function (rawData) {
      // MasterCard starts with 51-55, and is 16 digits long.
      const pattern = new RegExp(
        "^%B(5[1-5][0-9]{14})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})"
      );

      const match = pattern.exec(rawData);
      if (!match) return null;

      const account = match[1];
      if (!luhnChecksum(account)) return null;

      const cardData = {
        type: "mastercard",
        cardNumber: account,
        lastName: match[2],
        firstName: match[3],
        honorific: match[4] ? match[4].trim().slice(1) : "",
        expirationYear: match[5],
        expirationMonth: match[6],
      };

      return cardData;
    },

    // Discover parser.
    function (rawData) {
      // discover starts with 6, and is 16 digits long.
      const pattern = new RegExp(
        "^%B(6[0-9]{15})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})"
      );

      const match = pattern.exec(rawData);
      if (!match) return null;

      const account = match[1];
      if (!luhnChecksum(account)) return null;

      const cardData = {
        type: "discover",
        cardNumber: account,
        lastName: match[2],
        firstName: match[3],
        honorific: match[4] ? match[4].trim().slice(1) : "",
        expirationYear: match[5],
        expirationMonth: match[6],
      };

      return cardData;
    },

    // American Express parser
    function (rawData) {
      // American Express starts with 34 or 37, and is 15 digits long.
      const pattern = new RegExp(
        "^%B(3[4|7][0-9]{13})\\^([A-Z ]+)/([A-Z ]+)(\\.[A-Z ]+)?\\^([0-9]{2})([0-9]{2})"
      );

      const match = pattern.exec(rawData);
      if (!match) return null;

      const account = match[1];
      if (!luhnChecksum(account)) return null;

      const cardData = {
        type: "amex",
        cardNumber: account,
        lastName: match[2],
        firstName: match[3],
        honorific: match[4] ? match[4].trim().slice(1) : "",
        expirationYear: match[5],
        expirationMonth: match[6],
      };

      return cardData;
    },
  ];

  let cardDetails = null;

  creditCardParsers.forEach((parser) => {
    if (cardDetails) return;
    cardDetails = parser(inpValue);
  });
  return cardDetails;
};
